<template>
  <div class="tobacco-intelligent-logistics-distribution">
    <top-nav :banner="data.banner" color="#333333" isParent></top-nav>
    <pain></pain>
    <tech-empowerment></tech-empowerment>
    <comm-scene :dataKey="'tobacco-intelligent-logistics-distribution'" scene-key="applicationScenarios"></comm-scene>
    <product-list coloredbg></product-list>
    <customer-wall></customer-wall>
    <footer-resolution></footer-resolution>
    <my-footer></my-footer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Pain from './components/pain.vue';
import TechEmpowerment from './components/tech-empowerment.vue';
import CustomerWall from '@/views/index-view/customer-wall.vue';

export default {
  components: {
    Pain,
    TechEmpowerment,
    CustomerWall
  },
  computed: {
    ...mapGetters(['globalData']),
    data() {
      return this.globalData['tobacco-intelligent-logistics-distribution'];
    }
  }
};
</script>

<style lang="scss" scoped>
.tobacco-intelligent-logistics-distribution {
  background: #ffffff;

  ::v-deep .banner-item-brief {
    width: 42%;
    font-size: 24px;
    line-height: 1.5;
    color: white!important;
    text-shadow: 1px 1px 2px #000;
  }

  ::v-deep .banner-item-title {
    color: white!important;
    text-shadow: 1px 1px 2px #000;
  }

  ::v-deep .banner-list .banner-item .banner-buttons {
    bottom: 18%;
  }
}
</style>
